import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Layout from "@/components/Layout";

import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import Dashboard from "@/pages/Dashboard";
import MasterProduct from "@/pages/master/MasterProduct";
import MasterMaterial from "@/pages/master/MasterMaterial";
import MasterLabor from "@/pages/master/MasterLabor";
import MasterOverhead from "@/pages/master/MasterOverhead";
import EmissionFactor from "@/pages/master/EmissionFactor";
import Orders from "@/pages/Orders";
import Batches from "@/pages/Batches";
import MaterialUsage from "@/pages/MaterialUsage";
import LaborCost from "@/pages/LaborCost";
import OverheadCost from "@/pages/OverheadCost";
import EnvironmentalCost from "@/pages/EnvironmentalCost";
import HppCalculation from "@/pages/HppCalculation";
import AIAnalytics from "@/pages/AIAnalytics";
import Simulation from "@/pages/Simulation";
import Reports from "@/pages/Reports";
import UserManagement from "@/pages/UserManagement";
import Settings from "@/pages/Settings";
import AuditLog from "@/pages/AuditLog";

const App = () => (
  <AuthProvider>
    <BrowserRouter>
      <Toaster position="top-right" richColors />
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/login" element={<Login />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route
          path="/app/*"
          element={
            <ProtectedRoute>
              <Layout>
                <Routes>
                  <Route path="dashboard" element={<Dashboard />} />
                  <Route path="master/produk" element={<MasterProduct />} />
                  <Route path="master/material" element={<MasterMaterial />} />
                  <Route path="master/tenaga-kerja" element={<MasterLabor />} />
                  <Route path="master/overhead" element={<MasterOverhead />} />
                  <Route path="master/faktor-emisi" element={<EmissionFactor />} />
                  <Route path="pesanan" element={<Orders />} />
                  <Route path="produksi" element={<Batches />} />
                  <Route path="material-usage" element={<MaterialUsage />} />
                  <Route path="labor-cost" element={<LaborCost />} />
                  <Route path="overhead-cost" element={<OverheadCost />} />
                  <Route path="environmental-cost" element={<EnvironmentalCost />} />
                  <Route path="hpp" element={<HppCalculation />} />
                  <Route path="ai" element={<AIAnalytics />} />
                  <Route path="simulation" element={<Simulation />} />
                  <Route path="reports" element={<Reports />} />
                  <Route path="users" element={<UserManagement />} />
                  <Route path="settings" element={<Settings />} />
                  <Route path="audit" element={<AuditLog />} />
                  <Route path="*" element={<Navigate to="dashboard" replace />} />
                </Routes>
              </Layout>
            </ProtectedRoute>
          }
        />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  </AuthProvider>
);

export default App;
